import { render, staticRenderFns } from "./SpacesGuidelines.vue?vue&type=template&id=5f94a30c&scoped=true"
import script from "./SpacesGuidelines.vue?vue&type=script&lang=js"
export * from "./SpacesGuidelines.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f94a30c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/8268df4d62037a26/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f94a30c')) {
      api.createRecord('5f94a30c', component.options)
    } else {
      api.reload('5f94a30c', component.options)
    }
    module.hot.accept("./SpacesGuidelines.vue?vue&type=template&id=5f94a30c&scoped=true", function () {
      api.rerender('5f94a30c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/admin/components/BuildingsSpaces/SpacesGuidelines.vue"
export default component.exports